"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupAbsolute = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _Input = require("./Input");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/**
 * IconInputGroupAddon component *MUST BE FIRST CHILD INSIDE* InputGroupAbsolute component
 */

var InputGroupAbsolute = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.InputGroup, {
    children: children,
    className: className,
    onClick: onClick
  });
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  .input-group-text[addonType='prepend'] ~ ", " {\n    padding-left: 50px !important;\n  }\n  .input-group-text[addonType='append'] ~ ", " {\n    padding-right: 50px !important;\n  }\n"])), _Input.Input, _Input.Input);
exports.InputGroupAbsolute = InputGroupAbsolute;